module.exports = {}


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/icon.json
// module id = 1035
// module chunks = 367